import { render } from "./Header.vue?vue&type=template&id=6e3cd488"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "E:\\RSMentari\\Project RSM\\Portal RSM\\frontend-rsm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__